var _defs, _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sad_Face",
    "data-name": "Sad Face",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sad-cls-1{fill:#ff8110;}.sad-cls-2{fill:#fff;}.sad-cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sad Face") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "sad-cls-1",
    cx: 20.5,
    cy: 20.5,
    r: 20.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "sad-cls-2",
    cx: 13.45,
    cy: 14.73,
    r: 3.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "sad-cls-2",
    cx: 27.55,
    cy: 14.73,
    r: 3.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "sad-cls-3",
    d: "M84.25,82s-11.53-9.22-23.06,0",
    transform: "translate(-52.22 -52)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/Sad Face.71ee51187a11fa65062ce9a58d7fd590.svg";
export { ForwardRef as ReactComponent };